<i18n src="./resources/locales.json"></i18n>

<template>
  <section class="interaction-participant" :dark="$vuetify.theme.dark">
    <div class="avatar">
      <EcsAvatar :contact-id="participant.id" :alt="fullName" :size="40" stateful no-animation />
      <div class="media-type">
        <v-icon x-small dark>{{ mediaTypeIcon }}</v-icon>
      </div>
    </div>

    <div class="interaction-party-info">
      <div class="demands">
        <span v-for="(demand, index) in demands" :key="index" class="demand">
          {{ demand }}
        </span>
      </div>
      <div class="contact">
        <div class="name">{{ fullName }}</div>
        <div v-show="entryTime" class="interaction-duration">
          <span>{{ timePrefixLabel }} </span>
          <EcsLiveTimeAgo :since="entryTime" verbose />
          <span> {{ timeSuffixLabel }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsAvatar';
import EcsLiveTimeAgo from '@/components/ecs-live-time-ago/EcsLiveTimeAgo';

export default {
  name: 'EcsInteractionParticipant',

  components: { EcsAvatar, EcsLiveTimeAgo },

  props: {
    participant: {
      type: Object,
      default() {
        return {};
      }
    },
    mediaTypeIcon: {
      type: String,
      default: ''
    },
    demands: {
      type: Array,
      default: () => []
    },
    entryTime: {
      type: String,
      default: ''
    },
    timePrefixLabel: {
      type: String,
      default: ''
    },
    timeSuffixLabel: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters('CONTACTS', ['getContact']),

    fullName() {
      return this.participant.id ? this.getContact(this.participant.id).name : this.participant.name;
    }
  }
};
</script>

<style scoped lang="scss">
.interaction-participant {
  display: grid;
  grid-template-columns: 40px auto;
  grid-column-gap: 16px;

  & + .interaction-participant {
    margin-top: 16px;
  }

  .avatar {
    width: 44px;
    height: 44px;
    position: relative;

    .media-type {
      position: absolute;
      bottom: -8px;
      right: -8px;
      background-color: #4caf50;
      padding: 0 4px;
      border-radius: 50%;
      border: 2px solid var(--v-surface-lighten1);
      color: var(--v-surface-base);
    }
  }

  .interaction-party-info {
    margin-top: -2px;

    .demands {
      color: var(--v-primary-base);
      text-transform: uppercase;
      font-size: 11px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .demand + .demand:before {
        content: '-';
        padding: 0 4px;
      }
    }
    .contact {
      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .interaction-duration {
        font-size: 12px;
        opacity: 0.75;
      }
    }
  }
}

[dark].interaction-participant {
  --thread-lines-color: var(--v-surface-lighten2);
}
</style>
